<template>
  <v-dialog max-width="500" v-model="isOpen">
    <slot slot="activator">
      <v-btn fab color="success">
        <v-icon large>
          add
        </v-icon>
      </v-btn>
    </slot>

    <v-card>
      <v-card-title><h2 class="headline">New Task</h2></v-card-title>
      <v-card-text>
        <v-form>
          <v-autocomplete
            v-if="managed"
            v-model="assignedUserID"
            label="Assigned user (leave blank to self-assign)"
            :items="employeeFilters.concat(managerFilters)"
            item-text="name"
            item-value="id"
            :loading="employeesLoading && managersLoading"
            :disabled="employeesLoading && managersLoading"
            clearable
          />
          <v-text-field
            v-model="taskTitle"
            label="Task"
            required
            :rules="[v => !!v || 'Task title is required']"
          />
          <v-textarea
            v-model="taskDetails"
            label="Additional details"
            hint="optional"
            persistent-hint
          />
          <v-menu
            ref="dueDateMenu"
            v-model="dueDateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="dueOn"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template slot="activator" slot-scope="{ on }">
              <v-text-field
                label="Due Date"
                v-model="dueOn"
                prepend-icon="event"
                hint="optional"
                persistent-hint
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="dueOn" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="dueDateMenu = false"
                >Cancel</v-btn
              >
              <v-btn flat color="primary" @click="$refs.dueDateMenu.save(dueOn)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-menu>
          <v-switch
            v-if="managed"
            v-model="taskPriority"
            label="Priority?"
            hint="Get a message when this is completed. Also allows for easily sending reminders to assignee"
            persistent-hint
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" flat @click="cancel">Nevermind</v-btn>
        <v-btn color="success" :disabled="!taskTitle" @click="createTask"
          >Create</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import collectionApi from "@/api/collections.js";

export default {
  props: ["value", "managed", "forUserID", "initialDescription"],
  computed: {
    ...mapState("todos", ["listID"]),
    ...mapState("userAuth", ["user"])
  },
  data() {
    return {
      assignedUserID: null,
      employeesLoading: false,
      selectedUser: null,
      employeeFilters: [],
      managerFilters: [],
      dueDateMenu: false,
      isOpen: false,
      taskTitle: "",
      taskDetails: "",
      taskPriority: false,
      dueOn: null
    };
  },

  created() {
    // Set any default fields
    if (this.initialDescription) {
      this.taskDetails = this.initialDescription;
    }
  },

  watch: {
    isOpen(isOpen) {
      if (isOpen) {
        if (this.managed) {
          this.employeesLoading = true;
          this.managersLoading = true;

          collectionApi.getEmployees(employees => {
            this.employeeFilters = employees;
            this.employeesLoading = false;
          });

          collectionApi.getManagersList({ includeBoh: true }, managers => {
            this.managerFilters = managers;
            this.managersLoading = false;
          });

          this.assignedUserID = this.forUserID;
        }
      }
    }
  },
  methods: {
    createTask() {
      this.$store
        .dispatch("todos/createTodo", {
          assigned_user_id: this.assignedUserID || this.user.id,
          task: this.taskTitle,
          details: this.taskDetails,
          due_on: this.dueOn,
          priority: this.taskPriority
        })
        .then(r => {
          this.reset();
          this.close();
        });
    },
    cancel() {
      this.reset();
      this.isOpen = false;
    },
    close() {
      this.isOpen = false;
    },
    reset() {
      this.taskTitle = "";
      this.taskDetails = "";
      this.dueOn = null;
    },
    save() {
      // const form = this.$refs.form as VForm;
      //if (!form.validate()) {
      //return;
      //}
      // this.$emit('save');
    }
  }
};
</script>
